module.exports = __webpack_public_path__ + "static/media/jordancom.691e3a3c.jpg";